/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    /*
    PriceDropService is responsible for making Product detail page api calls for price drop info
    */
    angular
        .module('enervee')
        .factory('PriceDropService', [
            '$state',
            '$q',
            '$log',
            'ProductApiConsumerService',
            function(
                $state,
                $q,
                $log,
                ProductApiConsumerService
            ) {
                var _pub = {},
                    _priceChanges = {},
                    _priceDropPromises = {};

                /**
                 * Helper function for making the key for price drop requests
                 * @param {String|Array} productIds list of product ids to get price drop for
                 * @returns {String}
                 */
                var getRequestKey = function(productIds) {
                    if (Array.isArray(productIds)) {
                        return productIds.join(',');
                    }
                    return productIds;
                };


                /**
                 * Fetches the rebates for a list of product ids
                 * @param {Array} productIds list of product ids to get rebates for
                 * @param {Boolean} [force] if true, re-fetch the rebates even if
                 * they've already been fetched once
                 * @returns {$q.promise}
                 */
                var fetchPriceDropForProducts = function(productIds, force) {
                    var key = getRequestKey(productIds);
                    if (!_priceDropPromises[key] || force) {
                        _priceDropPromises[key] = ProductApiConsumerService.request({
                            method: 'GET',
                            url: '/api/1.0/price-drop/',
                            params: {
                                product_ids: productIds,
                            }
                        }).then(function(data) {
                            _priceChanges[key] = data.data;
                        }, function(error) {
                            $log.error(error);
                            _priceChanges[key] = {};
                        });
                    }
                    return _priceDropPromises[key];
                };

                /**
                 * Takes a list of productIds and queries the backend for price drop associated with
                 * the products that belong to the user's chosen provider.
                 * @param {String|Array} productIds list of product ids to get price drop for
                 * @param {Boolean} [force] if true, re-fetch the price drop even if
                 * they've already been fetched once
                 * @returns {$q.promise}
                 */
                _pub.getPriceChangeForProducts = function(productIds, force) {
                    var key = getRequestKey(productIds);
                    var deferred = $q.defer();
                    if (!_priceChanges[key] || force) {
                        fetchPriceDropForProducts(productIds, force).then(function() {
                            deferred.resolve(_priceChanges[key]);
                        }, function(error) {
                            deferred.reject(error);
                        });
                    } else {
                        deferred.resolve(_priceChanges[key]);
                    }
                    return deferred.promise;
                };

                return _pub;
            }
        ]);
})(angular);
